var lunarData = {"Waning Gibbous":{"moon":"Waning Gibbous","locket-variant":"42578591285481","icon":"waning_gibbous","affirmations":["I release what is no longer serving me","There is power within me","I let go of all that is not in alignment with my purpose","I choose to let go of the past and the future","I surrender all fears and doubts"],"gemstones":[{"name":"Citrine","icon":"citrine","description":"Known to help release doubt and promote self-love and confidence, sunny citrine will lift the energy of any wearer"},{"name":"Moonstone","icon":"moonstone","description":"Known to heighten intuition and new beginnings, moonstone encourages wearers to be more compassionate with themselves"}],"aspects":[{"title":"LETTING GO","description":"The waning gibbous phase urges us to let go of what doesn't serve us, and consequently people born in this phase have an innate sense of priorities and what's truly important, as symbolized by a growing tree shedding leaves.","icon":"letting_go"},{"title":"GROWTH IN CLARITY","description":"You have a clarity of vision that is totally unique and inspirational. The intention with which you navigate the world sets you apart, and if you ever feel adrift know that you have a strong internal voice that you should always trust.","icon":"clarity"},{"title":"GENEROUS WISDOM","description":"This moon phase embodies the teacher--you have everything to gain and nothing to lose from sharing your inspiration and wisdom with others, and providing support, guidance, or even just a helping hand or listening ear means the world.","icon":"gratitude"},{"title":"BE CAREFUL","description":"You are creative and wise beyond your years, which makes it even more of a mystery to those in your life that you can so easily be overcome with a feeling of doubt or a gnawing worry that there is something missing. Walk through the world with gratitude and confidence that you are enough.","icon":"careful"}]},"Waning Crescent":{"moon":"Waning Crescent","locket-variant":"42578591318249","icon":"waning_crescent","affirmations":["There is power within me","I am proud of how far I’ve come","Everything I’m looking for can be found within me","I honor the growth I have accomplished","I am becoming closer to my true self every day"],"gemstones":[{"name":"Black Tourmaline","icon":"black_tourmaline","description":"Known to help release doubt and promote self-love and confidence, sunny citrine will lift the energy of any wearer"},{"name":"Amethyst","icon":"amethyst","description":"An amazing crystal for clarifying your emotions, amethyst will being a calm composure to your life and help you manifest anything that you desire"}],"aspects":[{"title":"RECHARGE","description":"This moon phase is a time for processing and introspection. People born under a waning crescent know the value of self care and recharging their energies more than most.","icon":"recharge"},{"title":"LOOK WITHIN","description":"You have a unique ability to find the answers to life's questions by looking within. This is a spiritual and introspective moon phase, symbolized by the solitary woman contained within the crescent moon.","icon":"look_within"},{"title":"TRANSFORMATION","description":"There's a certain heaviness and emotional weight to those born under this moon phase. Your natural connection with your spirituality makes you resilient and able to do the hard but essential emotional work that sets you apart from the rest.","icon":"take_flight"},{"title":"BE CAREFUL","description":"Your gift for introspection and a penchant for specific interests and hobbies makes you somewhat of a recluse at times. There is nothing wrong with spending time by yourself, but don’t let it blossom into loneliness and social anxiety. Remember that there is great happiness and fulfillment that can be found in community with others.","icon":"careful"}]},"Waxing Crescent":{"moon":"Waxing Crescent","locket-variant":"42578591187177","icon":"waxing_crescent","affirmations":["I speak life into my present and future","I create my own reality","I have the power to shape my reality","I am creating the life of my dreams","I believe in the power of my dreams"],"gemstones":[{"name":"Blue Kyanite","icon":"blue_kyanite","description":"Great for defusing frustration, blue kyanite helps you speak your truth with confidence and clarity"},{"name":"Amethyst","icon":"amethyst","description":"An amazing crystal for clarifying your emotions, amethyst will being a calm composure to your life and help you manifest anything that you desire"}],"aspects":[{"title":"OPTIMISTIC MOTIVATION","description":"People born under a waxing crescent moon are naturally focused and optimistic people. A sensible yet positive energy is always present in you.","icon":"look_within"},{"title":"CLARITY AND INTENTION","description":"Creative and powerful, you know that the world is yours if you put the right energy into it. The pen nib and open arms symbolize your power in manifestation and receiving the energies you put into the universe.","icon":"clarity"},{"title":"TAKE FLIGHT","description":"You have everything you need and if you don't, deep down you know what to do to receive it. All you need to do is spread your wings!","icon":"take_flight"},{"title":"BE CAREFUL","description":"Your creativity and drive are admirable, but it can also manifest in stubbornness. While you may be more prone to getting caught up in pride and needless arguments, remember that your strong sense of direction can be wielded positively to foster success and support for everyone around you.","icon":"careful"}]},"New Moon":{"moon":"New Moon","locket-variant":"42578591154409","icon":"new_moon","affirmations":["I embrace each opportunity to start fresh","I am open to new beginnings","Each day/moment is a new beginning","My life is overflowing with limitless potential","I am full of endless potential","I believe that anything is possible"],"gemstones":[{"name":"Peridot","icon":"peridot","description":"washing away unhealthy patterns, negative emotions, and ego, sunny peridot will let you take on the world with joy and openness"},{"name":"Smoky Quartz","icon":"smoky_quartz","description":"uplifting and positive, smoky quartz will ground and balance you while opening up channels of communication"}],"aspects":[{"title":"INTUITION","description":"People born under a new moon were born without the guiding light of the moon, so are gifted with a strong internal compass and keen intuition, symbolized by the strong light radiating from within the lotus flower.","icon":"look_within"},{"title":"LOTUS FLOWER","description":"A powerful symbol of rebirth, the ancient Egyptians believed that the lotus flower had the power to breathe new life into the deceased. You have an energizing affect on those around you, and are constantly planting seeds of greatness.","icon":"lotus"},{"title":"NEW BEGINNINGS","description":"The subtly intertwined infinity sign symbolizes the enthusiasm with which you always embrace new opportunities and your endless pursuit of new knowledge and territory.","icon":"take_flight"},{"title":"BE CAREFUL","description":"Used to following the light of your own strong intuition, sometimes you can be a bit headstrong and struggle to trust others. You’ll be surprised to see what is possible if you let others in and allow yourself to learn from them.","icon":"careful"}]},"Full Moon":{"moon":"Full Moon","locket-variant":"42578591252713","icon":"full_moon","affirmations":["I invite gratitude into my heart","I see/move through the world with love and gratitude","I am grateful for who I am and where I am","I am proud of everything I’ve achieved"],"gemstones":[{"name":"Aquamarine","icon":"aquamarine","description":"clarifies mind and promotes confident communication, also known as a ‘good luck stone’"},{"name":"Blue Kyanite","icon":"blue_kyanite","description":"Great for defusing frustration, blue kyanite helps you speak your truth with confidence and clarity"}],"aspects":[{"title":"FULL BLOOM","description":"You were born under the brightest of the moon, and you've always been destined to shine just as bright! The moon flower blooms only under the light of the full moon, and just like you, soaks up every bit of light in its beautiful and rare petals.","icon":"bloom"},{"title":"GRATITUDE","description":"The full moon is a time for everyone to reflect and express gratitude, and as such one of your best qualities is a keen awareness of everyone and everything in your life you have to be grateful for, symbolized by the open and grateful hands.","icon":"gratitude"},{"title":"BALANCE IN LOVE","description":"The sun and the moon are exactly opposite each other during a full moon, so lasting relationships are incredibly important for the growth and happiness of people born under this moon phase. Anyone would be lucky to love you, and you are equally excited to support those you love and help them thrive.","icon":"balance"},{"title":"BE CAREFUL","description":"You are full of emotions and can be prone to mood swings, often battling between what your head and what your heart wants. With a heart and mind so strong, you can sometimes be indecisive or struggle to speak openly, though you never lack ideas. If anything, you can be overwhelmed by the abundance of thoughts, emotions, and perspectives that you’re constantly weighing!","icon":"careful"}]},"Waxing Gibbous":{"moon":"Waxing Gibbous","locket-variant":"42578591219945","icon":"waxing_gibbous","affirmations":["I live in a state of complete abundance","My strength is greater than any struggle","I celebrate where I am and am grateful for where I am going","I am growing and learning every day"],"gemstones":[{"name":"Rose Quartz","icon":"rose_quartz","description":"one of the most widely used stones for joy, the ‘love stone’ will attract love and light of all shades"},{"name":"Black Tourmaline","icon":"black_tourmaline","description":"protective stone, black tourmaline shields you from any negativity and will work wonders for cultivating positive energy in your life"}],"aspects":[{"title":"ABUNDANCE","description":"People born under a waxing gibbous moon naturally attract abundance and are constantly looking to expand themselves and their world view. The fish and the nautical wheel symbolize your keen awareness of your place within a world of abundance.","icon":"abundance"},{"title":"LET LIGHT IN","description":"Your open mind is one of your most beautiful qualities. You know more than most that in order to radiate, you need to let the light in first.","icon":"light"},{"title":"LOOK WITHIN","description":"You have a unique ability to truly see yourself, which is why this is the only design featuring a face. Your introspection and dedication to developing yourself will bring you through life with grace.","icon":"look_within"},{"title":"BE CAREFUL","description":"You are wise beyond your years, but this can sometimes make you seem cold. Don’t forget to enjoy the little things in life and let your inner child out every once in a while!","icon":"careful"}]}}
var _learnq = _learnq || [];
var viaQueryParam = false

document.addEventListener('page:loaded', function() {
  toggleResults(false)

  document.getElementById("show-results-button").addEventListener('click', (event) => {
        toggleResults(true)
  });

   const params = new URLSearchParams(window.location.search);
   const encodedDate = params.get("phase")

   if (encodedDate) {
    var date = decodeDate(encodedDate)
    console.log(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate())
    document.getElementById("lunar-birthday").value = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    viaQueryParam = true
    setPhaseForDate(date)
    toggleResults(true)
   }

    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: true,
      custom_success_message: true,
      extra_properties: {
        $source: 'moon-phase-calculator-top',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text',
      },
      success: function ($form) {
        _learnq.push(['track', 'Completed Lunar Phase Quiz']);
        toggleResults(true)
        if (ttq) {
            ttq.track('SubmitForm', {})
        }

        }
    });

    KlaviyoSubscribe.attachToForms('#email_signup_bottom', {
      hide_form_on_success: true,
      custom_success_message: true,
      extra_properties: {
        $source: 'moon-phase-calculator-bottom',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text',
      },
      success: function ($form) {
        _learnq.push(['track', 'Completed Lunar Phase Quiz']);

        if (ttq) {
            ttq.track('SubmitForm', {})
        }



        }
    });


});



function setData(phase) {
    var page = {
        phaseTitle: document.querySelector('[id$="result-moon-phase-block"]').getElementsByTagName("h2")[0] ,
        phaseImage: document.querySelector('[id$="result-moon-phase-block"]').getElementsByTagName("img")[0],
        phaseAspects: document.querySelector('[id$="result-moon-phase-aspects"]'),
        gemstone1: {
            image: document.querySelector('[id$="result-gemstone-1"]').getElementsByTagName("img")[0],
            title: document.querySelector('[id$="result-gemstone-1"]').getElementsByClassName("subheading")[0],
            text: document.querySelector('[id$="result-gemstone-1"]').getElementsByTagName("p")[0],
            button: document.querySelector('[id$="result-gemstone-1"]').getElementsByClassName("btn")[0]
        },
        gemstone2: {
            image: document.querySelector('[id$="result-gemstone-2"]').getElementsByTagName("img")[0],
            title: document.querySelector('[id$="result-gemstone-2"]').getElementsByClassName("subheading")[0],
            text: document.querySelector('[id$="result-gemstone-2"]').getElementsByTagName("p")[0],
            button: document.querySelector('[id$="result-gemstone-2"]').getElementsByClassName("btn")[0]
        },
        affirmations: document.querySelector('[id$="result-affirmations"]'),
        locketLink: document.querySelector('[id$="result-moon-phase-aspects"]')
    }

    const phaseData = lunarData[phase]
    page.phaseTitle.innerHTML = phaseData.moon
    page.phaseImage.srcset = ""
    page.phaseImage.src = replaceFileName(page.phaseImage.src,phaseData.icon)
    page.phaseImage.setAttribute("data-src", replaceFileName(page.phaseImage.src,phaseData.icon))
    page.gemstone1.title.innerHTML = phaseData.gemstones[0].name
    page.gemstone2.title.innerHTML = phaseData.gemstones[1].name
    page.gemstone1.text.innerHTML = phaseData.gemstones[0].description
    page.gemstone2.text.innerHTML = phaseData.gemstones[1].description
    page.gemstone1.image.src = replaceFileName(page.gemstone1.image.src,phaseData.gemstones[0].icon)
    page.gemstone1.image.setAttribute("data-src", replaceFileName(page.gemstone1.image.src,phaseData.gemstones[0].icon))
    page.gemstone1.image.srcset = ""
    page.gemstone2.image.src = replaceFileName(page.gemstone2.image.src,phaseData.gemstones[1].icon)
    page.gemstone2.image.srcset = ""
    page.gemstone2.image.setAttribute("data-src", replaceFileName(page.gemstone2.image.src,phaseData.gemstones[1].icon))
    page.gemstone1.button.innerHTML = "Shop " + phaseData.gemstones[0].name
    page.gemstone2.button.innerHTML = "Shop " + phaseData.gemstones[1].name
    page.gemstone1.button.href = "https://www.jewelrybyserendipity.com/collections/all?filter.v.option.stone=" + phaseData.gemstones[0].name
    page.gemstone2.button.href = "https://www.jewelrybyserendipity.com/collections/all?filter.v.option.stone=" + phaseData.gemstones[1].name
    
    setAspects(page.phaseAspects,phaseData.aspects)
    setAffirmations(page.affirmations,phaseData.affirmations)
}


//show/hides the results
function toggleResults(show) {
    const picker = document.querySelector('[id$="moon-phase-date-picker"]')
    const containerChildren = picker.parentElement.childNodes
    var reachedPicker = false
    for (const element of containerChildren) {
        if (reachedPicker && element.style) { element.style.display = show ? "" : "none" }
        if (element == picker) { reachedPicker = true }
    } 
}

function setAffirmations(node,data) {
    //remove border and padding
    var nodes = node.getElementsByTagName("h2")
    for (var i = 0;i<nodes.length;i++) {
        var el = nodes[i]
        el.innerHTML = data[i]
        el.style = "text-transform: none;font-style: italic;"
    }
    node.children[1].style = "padding: 0px; border-top: 0px"

}


function setPhaseForDate(date) {
    var phase = window.lunarphase.js.Moon.lunarPhase(date)
    var sign = findSign(date.getUTCMonth()+1,date.getUTCDate())
    setKlayvioData(sign,phase,date)
    document.getElementById("moon-phase-info").style.display = "";
    setQueryStringParameter("phase",encodeDate(date))
    setData(phase)
    setElement(date)
}



function setAspects(root,aspects) {
    var nodes = root.querySelectorAll('[class^="testimonials-slide-"]')
    for (var i = 0;i<aspects.length; i++) {
        var el = nodes[i]
        el.getElementsByTagName("h2")[0].innerHTML = aspects[i].title
        el.getElementsByTagName("p")[0].innerHTML = aspects[i].description
        var img = el.getElementsByTagName("img")[0]
        img.src = replaceFileName(img.src,aspects[i].icon)
        img.srcset = ""
        img.setAttribute("data-src",img.src)
    }
}


function setElement(date) {
    var image = document.querySelector('[id$="result-element-block"]').getElementsByTagName("img")[0]
    var title = document.querySelector('[id$="result-element-block"]').getElementsByTagName("h2")[1]
    var text = document.querySelector('[id$="result-element-block"]').getElementsByTagName("p")[0]
    var sign = findSign(date.getUTCMonth()+1,date.getUTCDate())

    if (["Cancer","Scorpio","Pisces"].includes(sign)) {
        //water
        image.src = replaceFileName(image.src,"water")
        title.innerHTML = "Water"
        text.innerHTML = "You bring a sensitivity, creativity and strong intuition to everything you do which makes people seek you out for support and guidance"
    } else if (["Libra","Gemini","Aquarius"].includes(sign)) {
        //air
        image.src = replaceFileName(image.src,"air")
        title.innerHTML = "Air"
        text.innerHTML = "Creative and intelligent, you have the capacity to be both the problem solver and the life of the party as your spirit is free and never bogged down by attempts to stifle or restrict you"
    } else if (["Capricorn","Virgo","Taurus"].includes(sign)) {
        //earth
        image.src = replaceFileName(image.src,"earth")
        title.innerHTML = "Earth"
        text.innerHTML = "You are grounded and trustworthy and have the unique gift of being able to create a life and environment that you can truly enjoy wherever you go"
    } else if (["Aries","Leo","Sagittarius"].includes(sign)) {
        //fire
        image.src = replaceFileName(image.src,"fire")
        title.innerHTML = "Fire"
        text.innerHTML = "You are inspired, passionate, and creative, and you never fail to bring an energizing light to the people and spaces around you"
    }
    image.setAttribute("data-src",image.src)
    image.srcset = ""
}


// Klayvio subscribe
function setKlayvioData(sign,phase,date) {
    var emailFormItem = document.getElementById("k_id_email")
    var dateString = [date.getUTCMonth()+1,date.getUTCDate(),date.getUTCFullYear()].join("/")

    document.getElementById("kl-Birthday").value = dateString
    document.getElementById("kl-zodiac").value = sign
    document.getElementById("kl-moonphase").value = phase
    console.log(sign,phase,dateString)

    if (_learnq && _learnq.isIdentified() && !viaQueryParam) {
        _learnq.push(['identify', {'zodiac': sign,'moonphase': phase,'Birthday': dateString}]);
        toggleResults(true)
        return
    }
        
}

function showResults(phase) {
    console.log("show phase " + phase)
    document.getElementById("k_id_email").parentElement.style.display = "none"
}



// Event listners
document.getElementById("lunar-birthday").addEventListener('focusout', (event) => {
    const date = new Date(event.target.value)
    if (window.lunarphase && window.lunarphase.js.Moon.lunarPhase(date)) {
        setPhaseForDate(date)
    }
});

document.getElementById("lunar-phase-submit").addEventListener('click', (event) => {
    const date = new Date(document.getElementById("lunar-birthday").value)
    if (window.lunarphase && window.lunarphase.js.Moon.lunarPhase(date)) {
        setPhaseForDate(date)
    }
});



// url encode / decode stuff
var key = ["a","b","c","A","d","e","f","h","R","z"]
//in format date.getTime()
function encodeDate(date) {
    const arr = date.getTime().toString().split("")
    var string = arr.map((num) => { 
        var num = parseInt(num)
        if (isNaN(num)) { return "q" }
        return key[num] 
    })
    return string.join("")
}

function decodeDate(string) {
    const arr = string.split("")
    var string = arr.map((s) => { 
        return key.indexOf(s)
    })
    return new Date(parseInt(string.join("")))
}


function setQueryStringParameter(name, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(name, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}

// Zodiac Sign
function findSign(month,day) {
    var mon = parseInt(month);
    var day = parseInt(day);
    var words = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
    var days = [ 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    if(mon < 1 || mon > 12 || day < 1 || day > days[mon - 1]) {
        return ""
    }
    var val = mon * 100 + day;
    if(val >= 321 && val <= 419) {
        return words[0];
    } else if(val >= 420 && val <= 520) {
        return words[1];
    } else if(val >= 521 && val <= 621) {
        return words[2];
    } else if(val >= 622 && val <= 722) {
        return words[3];
    } else if(val >= 723 && val <= 822) {
        return words[4];
    } else if(val >= 823 && val <= 922) {
        return words[5];
    } else if(val >= 923 && val <= 1023) {
        return words[6];
    } else if(val >= 1024 && val <= 1122) {
        return words[7];
    } else if(val >= 1123 && val <= 1221) {
        return words[8];
    } else if(val >= 1222 || val <= 119) {
        return words[9];
    } else if(val >= 120 && val <= 218) {
        return words[10];
    } else if(val >= 219 && val <= 320) {
        return words[11];
    }
    return ""
}

// Image URL Helpers
function replaceFileName(url,filename) {
    // Not sure how to do this correctly. 
    // This takes an existing asset URL and replaces with a new asset. While preserving the CDN URL in case it changes. 
    var fileURL = "//cdn.shopify.com/s/files/1/1153/5914/t/46/assets/" + filename + ".png"
    
    return fileURL

    //the original version doesnt work cause files are stored in shopify files not asset folder. doing this until I figure out a better way.
    // var urlparts = url.split("/")
    // urlparts[urlparts.length-1] = 
    // return urlparts.join("/")
}